import { render, staticRenderFns } from "./comparePanel.vue?vue&type=template&id=6527a138&"
import script from "./comparePanel.vue?vue&type=script&lang=js&"
export * from "./comparePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports